<template>
  <div class="activity-receive-discount" v-if="activityDetail">
    <div class="activity-discount-box">
      <!-- 总折扣 -->
      <div :class="['activity-discount-top']">
        <div class="discount-total" :class="[options.hideTimer ? 'text-center' : '']">
          <div class="spend-amount">
            <span>本月下单满<span class="amount-number">{{getFullNumberText(activityDetail.total_threshold_num, isFullAmount) }}</span>{{getUnit(isFullAmount) }}</span>
          </div>
          <div class="coupon-amount">
            <span>累计可领取<span class="amount-number">{{ getFullNumberText(activityDetail.total_coupon_amount, isFullAmount) }}</span>{{getUnit(isFullAmount) }}优惠</span>
          </div>
        </div>

        <!-- 活动倒计时部分 -->
        <div class="countdown-time" v-if="!options.hideTimer">
          <count-down-timer :end-date="activityDetail.end_time"></count-down-timer>
        </div>
      </div>

      <!-- 领取折扣部分 -->
      <div class="activity-discount-content">
        <div class="discount-coupon">
          <div class="discount-process" v-if="activityDetail.rule_list && activityDetail.rule_list.length">
            <div class="discount-process-active" :style="{'width': processWidth+'%'}"></div>
          </div>
          <div class="discount-list">
            <div 
              :class="['discount-item', (currentThreshod && currentThreshod.threshold_num == item.threshold_num  ? 'next-received' : ''), (currentThreshod && currentThreshod.threshold_num == item.threshold_num && !options.hideTips  ? 'discount-arrow' : ''), (item.is_claimed ? 'is-received' : '')]" 
              v-for="(item,index) in activityDetail.rule_list" 
              :key="index"
              @click="onRedivDiscountTips(item)"
            >
              <div class="spend-money">满{{isFullAmount ? item.threshold_num/100+'元' : item.threshold_num+'单'}}</div>
              <div class="coupon-item"></div>
              <div class="coupon-money">¥{{getCouponTotalAmount(item.coupon_list)}}</div>
            </div>
          </div>
        </div>

        <div class="discount-tips" v-if="!options.hideTips && currentThreshod">
          <div class="tips-text">
            再下单<span class="amount-number">{{getFullNumberText(currentThreshod.threshold_num - activityDetail.crrent_pay_num, isFullAmount)}}</span>{{ getUnit(isFullAmount) }}
            ，即可获得价值<span class="amount-number">{{ getCouponSum(currentThreshod.coupon_list) }}</span>元的优惠券
          </div>
          <!-- <div class="reminder-me" bind:tap="onReminderMe">提醒我</div> -->
        </div>

      </div>
      
    </div>
  </div>
</template>

<script>
import countDownTimer from '@/components/activity/count-down-timer';
import Http from '@/libs/http';


export default {
  components: {
    countDownTimer,
  },
  props: {
    peerActivityRecordId: Number,
    initActivityDetail: Object,
    options: {
      type: Object,
      default: {
        hideTimer: false, // 隐藏倒计时
      },    
    },
  },
  data() {
    return {
      threshodInfo: undefined, // 当前点击的门槛信息
      activityDetail: undefined,
    };
  },
  created() {
    if (this.peerActivityRecordId) {
      this.getActivityDetail();
    } else if (this.initActivityDetail) {
      this.activityDetail = this.initActivityDetail;
    }
  },
  computed: {
    // 为满单活动
    isFullOrder() {
      // 1促销活动 2新人活动 3满减活动 4满单活动
      return this.activityDetail && this.activityDetail.activity_type_id === 4;
    },
    // 满减活动
    isFullAmount() {
      // 1促销活动 2新人活动 3满减活动 4满单活动
      return this.activityDetail && this.activityDetail.activity_type_id === 3;
    },
    // 下一级门槛
    nexThreshod() {
      if (!this.activityDetail || !this.activityDetail.rule_list) return;
      // 拿到第一个未领取的设置未下一个门槛
      const nexThreshod = this.activityDetail.rule_list.find(rule => rule.threshold_num >= this.activityDetail.crrent_pay_num && !rule.is_claimed);// 0 未领取 1已领取
      return nexThreshod;
    },
    // 当前门槛进度
    nexThreshodIndex() {
      if (!this.activityDetail || !this.activityDetail.rule_list) return;
      const nexThreshodIndex = this.activityDetail.rule_list.findIndex(rule => rule.threshold_num >= this.activityDetail.crrent_pay_num && !rule.is_claimed);// 0 未领取 1已领取
      return Math.min(nexThreshodIndex, this.activityDetail.rule_list.length - 1);
    },
    // 进度条百分比
    processWidth() {
      if (!this.activityDetail || !this.activityDetail.rule_list) return 0;
      // 全部已经领取
      const isAllReceive = this.activityDetail.rule_list.every(item => item.is_claimed);
      if (isAllReceive) return 100;
      return 100 / (this.activityDetail.rule_list.length) * this.nexThreshodIndex;
    },
    // 当前门槛(默认的下一级门槛 + 用户选中查看的门槛)
    currentThreshod() {
      if (this.threshodInfo) return this.threshodInfo;
      return this.nexThreshod;
    },
  }, 
  methods: {
    // 获取活动详情
    async getActivityDetail() {
      if (!this.peerActivityRecordId) return;
      try {
        const res = await Http.post('/activity_discount_query', {
          peer_activity_record_id: this.peerActivityRecordId,
        });
        this.activityDetail = res;
      } catch (e) {
        console.log(e);
      }
    },
    getCouponTotalAmount(list) {
      if (!list) return 0;
      let total = 0;
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        total += item.coupon_amount * item.count;
      }
      return total / 100;
    },

    // 数字转换，满额需要进行转换
    getFullNumberText(number, isAmount) {
      number = number > 0 ? number : 0;
      if (isAmount) {
        return number / 100;
      }
      return number;
    },

    getUnit(isAmount) {
      return isAmount ? '元' : '单';
    },

    getCouponSum(list) {
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        sum += list[i].coupon_amount * list[i].count;
      }
      return sum / 100;
    },
  },
};

</script>

<style lang="less" scoped>
@primary-color: #F43344;

.activity-receive-discount {
  width: 100%;
  .activity-discount-box {
    width: 100%;
    font-size: 14px;
    line-height: 1;
    .activity-discount-top {
      display: flex;
      align-items: center;
      font-weight: 600;
      .discount-total {
        flex: 1;
        display: flex;
        align-items: center;
        &.text-center {
          justify-content: center;
        }
        .spend-amount, .coupon-amount {
          color: #2F333D;
          .amount-number {
            color: #FF033E;
            padding: 0 4px;
          }
        }
      }
      
      .countdown-time {
        text-align: right;
      }
    }
    .activity-discount-content {
      margin-top: 16px;
      .discount-coupon {
        border-radius: 2px;
        padding: 24px 11%;
        background: rgba(244, 51, 68, 0.03);
        position: relative;
        .discount-process {
          width: 70%;
          height: 6px;
          background-color: #EEEBEB;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .discount-process-active {
            background: @primary-color;
            border-radius: 4px;
            width: 0%;
            height: 6px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }
        }
        .discount-list {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .discount-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            &.is-received {
              .coupon-money {
                color: #91999F;
              }
              .coupon-item {
                background: url(../../assets/imgs/activity/full-amount-activity/received-discount.png) no-repeat center;
                background-size: 100% 100%;
              }
            }
            &.next-received {
              .coupon-money {
                background: rgba(244,51,68,0.08);
                color: @primary-color;
              }
              .coupon-item {
                width: 60px;
                height: 46px;
                background: url(../../assets/imgs/activity/full-amount-activity/current-discount.png) no-repeat center;
                background-size: 100% 100%;
              }
            }
            &.discount-arrow {
              position: relative;
              &::before {
                content: '';
                position: absolute;
                bottom: -44px; /* 调整三角形位置 */
                left: 50%;
                transform: translateX(-50%);
                width: 0;
                height: 0;
                border-left: 12px solid transparent;
                border-right: 12px solid transparent;
                border-bottom: 12px solid #FFEFF0;
              }
            }
            .spend-money {
              color: #91999F;
              margin-bottom: 12px;
            }
            .coupon-money {
              margin-top: 12px;
              padding: 2px 12px;
              color: #91999F;
              border-radius: 12px;
            }
            .coupon-item {
              width: 38px;
              height: 46px;
              background: url(../../assets/imgs/activity/full-amount-activity/default-discount.png) no-repeat center;
              background-size: 100% 100%;
            }
          }
        }
        
      }
      .discount-tips {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 2px;
        background: #FFEFF0;
        position: relative;
        .tips-text {
          flex: 1;
          padding: 14px 16px;
          color: #2F333D;
          .amount-number {
            color: @primary-color;
          }
        }
        .reminder-me {
          background: #FFFFFF;
          border-radius: 2px;
          border: 1px solid #F43344;
          color: #F43344;
          line-height: 20px;
          padding: 6px 30px;
          white-space: nowrap;
          background: #FFFFFF;
        }
      }
      
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/activity-receive-discount.vue